import React, { useCallback } from 'react';

import { SiteConfigManager } from '@atlas/core';
import { EmptyStateView, Loader } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Casino/CasinoFilterContext';
import { CasinoSearchCategoryGames } from 'src/components/Casino/CasinoGamesList';
import { GAME_SIZES } from 'src/components/Casino/constants';
import {
  casinoFilterTypeMap,
  deleteCasinoFilter,
  updateCasinoFilter,
} from 'src/components/Casino/useCasinoFilter';
import { scrollToTopHandler } from 'src/components/Footer/scrollToTopHandler';
import PropTypes from 'prop-types';

const sliderSettings = { rows: 2, size: GAME_SIZES.SMALL };

export const CasinoRecommendedGames = ({ loading, setActiveItem }) => {
  const { updateFilter } = useCasinoFilterState();
  const homePageFunctionality = SiteConfigManager.getConfig(
    'config.config.casino.desktop_home_page',
  );
  const showCategoryHandler = useCallback(
    categoryId => () => {
      if (homePageFunctionality) {
        setActiveItem(categoryId.toString());
      } else {
        updateFilter({ categories: [categoryId.toString()] });
        updateCasinoFilter(casinoFilterTypeMap.category, categoryId);
      }

      updateFilter({ providerNames: [] });
      deleteCasinoFilter(casinoFilterTypeMap.providerNames);
      scrollToTopHandler('auto');
    },
    [homePageFunctionality, setActiveItem, updateFilter],
  );

  if (loading) {
    return (
      <div className="empty-state absolute">
        <Loader />
      </div>
    );
  }

  return (
    <div className="casino__recommended-games">
      <EmptyStateView
        description="casino_search_no_results_recommended_games"
        title="casino_search_no_results_title"
      />
      <CasinoSearchCategoryGames
        showCategoryHandler={showCategoryHandler}
        sliderSettings={sliderSettings}
      />
    </div>
  );
};

CasinoRecommendedGames.propTypes = {
  loading: PropTypes.bool,
  setActiveItem: PropTypes.func,
};
